<template>
  <div class="timeslots timeslots-wrapper px-1 mt-3">
    <div v-if="closed" class="text-primary px-1">Choose another day for a furry-tastic experience!<br/>We are closed on {{hours.dayOfWeek.description}}s.</div>
    <div v-else class="d-flex flex-wrap justify-content-center">
      <div v-if="timeSlots.length === 0 && !loading" class="text-primary px-5 px-md-0">There is no available time slot for the chosen day.</div>
      <template v-else>
        <time-slots-item v-for="(timeSlot, index) in timeSlots"
          :time-slot="timeSlot"
          :key="timeSlot.id"
          :index="index"
          @statusChange="handleStatusChange"/>
        <div v-if="noAvailableSlots" class="text-primary px-5 px-md-0">There is no available time slot for the chosen day.</div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { mapState } from 'vuex'
import { OpeningHourCacheMixin } from '@/mixins/Booking/OpeningHourCacheMixin'
import TimeSlotsItem from './TimeSlotsItem.vue'

export default {
  name: 'TimeSlots',
  mixins: [OpeningHourCacheMixin],
  data () {
    return {
      loading: false,
      available: true
    }
  },
  computed: {
    ...mapState('BookingSelectedDate', [
      'selectedDate'
    ]),
    ...mapState('BookingUpload', [
      'duration',
      'selectedPets',
      'stackGroupBooking'
    ]),
    ...mapState('TimeZone', [
      'selectedTimeZoneId'
    ]),
    hours () {
      return this.openingHours ? this.openingHours.find(oh => oh.dayOfWeek.id === this.selectedDate.getDay()) : null
    },
    closed () {
      return this.hours ? this.hours.closed : false
    },
    dateString () {
      return moment(this.selectedDate).tz(moment.tz.guess()).format('YYYY-MM-DD')
    },
    openingTimeString () {
      return this.hours ? this.hours.openingLocal.split('T')[1] : ''
    },
    closingTimeString () {
      return this.hours ? this.hours.closingLocal.split('T')[1] : ''
    },
    openingTime () {
      return this.openingTimeString ? moment.tz(`${this.dateString}T${this.openingTimeString}`, this.selectedTimeZoneId) : null
    },
    closingTime () {
      return this.closingTimeString ? moment.tz(`${this.dateString}T${this.closingTimeString}`, this.selectedTimeZoneId) : null
    },
    slotDurationMinutes () {
      return this.stackGroupBooking
        ? (this.selectedPets ?? []).reduce((sum, { appointmentDuration = 0 }) => sum + (appointmentDuration === 0 ? this.duration : appointmentDuration), 0)
        : this.duration
    },
    timeSlots () {
      const slots = []
      if (!this.openingTime || !this.closingTime) {
        return slots
      }
      for (let startTime = this.openingTime.clone(); startTime < this.closingTime; startTime.add(this.slotDurationMinutes, 'minutes')) {
        const endTime = startTime.clone().add(this.slotDurationMinutes, 'minutes')
        // Check if a slot's startTime is not yet in the past
        // Check if a slot's endTime is within business hours
        if (moment().isBefore(startTime) && endTime <= this.closingTime) {
          slots.push({
            id: Math.random().toString(36).substring(2, 10),
            startTime: startTime.format(),
            endTime: endTime.format(),
            status: {
              loading: false,
              available: true
            }
          })
        }
      }

      return slots
    },
    noAvailableSlots () {
      return !this.available && !this.loading
    }
  },
  methods: {
    handleStatusChange (value) {
      this.$set(this.timeSlots, value.index, value.timeSlot)
      this.updateStatus()
    },
    updateStatus () {
      this.loading = this.timeSlots.some(ts => ts.status && ts.status.loading)
      this.available = this.timeSlots.some(ts => ts.status && ts.status.available)
    }
  },
  components: {
    'time-slots-item': TimeSlotsItem
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .timeslots-wrapper {
    min-height: 10rem !important
  }
}
</style>
